import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { validateUser } from './api'; // Importa la función de validación
import { loginSuccess, loginFailure } from '../../actions/index';
import { Eye, EyeOff } from "lucide-react"
import './Login.css';
import logo from '../../icons/logistika.png';
import video from '../../icons/logistika.mp4';

const Login = () => {
  const dispatch = useDispatch();
  const [showVideo, setShowVideo] = useState(true);
  const [blurVideo, setBlurVideo] = useState(true); // Estado para el filtro de desenfoque
  const videoRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setBlurVideo(false); // Quita el filtro de desenfoque a los 3 segundos
    }, 1000);

    const timer2 = setTimeout(() => {
      const videoElement = videoRef.current;
      videoElement.classList.add('hidden');
    }, 3000); // Comienza el desvanecimiento a los 5 segundos

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  const handleVideoEnded = () => {
    setShowVideo(false);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    const form = event.target;
    const email = form.email.value;
    const password = form.password.value;

    try {
      const response = await validateUser(email, password);
      if (response && response.Id_User) {
        dispatch(loginSuccess(response));
      } else {
        dispatch(loginFailure(response.Error));
        alert(response.Error);
      }
    } catch (error) {
      alert(error.message);
      dispatch(loginFailure(error.message));
    }
  };

  return (
    <div>
      {showVideo ? (
        <div className="video-container">
          <video
            ref={videoRef}
            autoPlay
            muted
            onEnded={handleVideoEnded}
            className={`video ${blurVideo ? 'blur' : ''}`}
          >
            <source src={video} type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
        </div>
      ) : (
        <div className="login-container">
          <div className="login-box">
            <img src={logo} alt="Logo Logistika" className="login-logo" />
            <h3>Administración del sofware</h3>
            <h2>Iniciar Sesión</h2>
            <form onSubmit={handleLogin}>
              <div className="input-group">
                <label>E-mail:</label>
                <input type="email" name="email" required />
              </div>
              <div className="input-group">
                <label>Contraseña:</label>
                <input type={showPassword ? 'text' : 'password'} name="password" required />
                <button
                  className="eye-button"   
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
              <button className="button" type="submit">Ingresar</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
